export default __webpack_public_path__ + "static/media/wood-planks.7982e34b.jpg";